import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { ResourcesTab } from '@/components/admin/tabs';

// TeamManagement-only /admin surface — re-asserted now the shell admits
// Finance:View. See routes/admin/route.tsx for the full rationale.
export const Route = createFileRoute('/admin/resources')({
  beforeLoad: ({ context }) => {
    requireCapability(context, 'TeamManagement', CapabilityTier.View, '/admin/resources');
  },
  component: ResourcesTab,
});
